<ng-container *ngIf="board">
  <div nz-tooltip [nzTooltipTitle]="showTooltip ? boardName : ''">
    <app-team-icon
      *ngIf="
        board.type === BoardTypeBackend.workpage ||
        board.type === BoardTypeBackend.team ||
        board.type === BoardTypeBackend.project
      "
      [name]="boardName"
      [size]="size"
      [backgroundColor]="board.unsafeSubData?.backgroundColor"
    >
    </app-team-icon>

    <div
      *ngIf="!board.type || board.type === BoardTypeBackend.personal"
      class="user"
      [ngStyle]="styleForUserContainer()"
    >
      <nz-avatar nzIcon="user" [nzSrc]="board.userBoardConfig?.portraitUrl" [nzSize]="size - 4"></nz-avatar>
      <div class="dot" *ngIf="shouldDisplayUserStatus()"></div>
      <div
        class="leave"
        *ngIf="shouldDisplayRemoved()"
        nz-tooltip
        [nzTooltipTitle]="tooltip()"
        nzTooltipPlacement="bottom"
        [ngStyle]="leaveStyle()"
      >
        <span class="logout-icon" nz-icon nzType="logout" nzTheme="outline"></span>
      </div>
    </div>

    <div *ngIf="board.type === BoardTypeBackend.tag" class="icon-container" [ngStyle]="styleForTagContainer()">
      <span nz-icon nzType="tag" nzTheme="outline"></span>
    </div>
  </div>
</ng-container>
